import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Role } from 'src/app/global/services/access-control/access-control.model';

@Component({
    selector: 'app-role-selector',
    templateUrl: './role-selector.component.html',
    styleUrls: ['./role-selector.component.scss'],
})
export class RoleSelectorComponent implements OnInit {
    isOpen = false;

    @Input() role: Role[];
    @Output() selected = new EventEmitter<Role[]>();

    roles: Role[] = [];

    ngOnInit(): void {
        this.roles = this.role;
    }

    toggleDropdown(): void {
        this.isOpen = !this.isOpen;
    }

    toggleRole(roleId: string): void {
        const role = this.roles.find((r) => r.id === roleId);
        if (role) {
            role.selected = !role.selected;
            this.selected.emit(this.getSelectedRoles());
        }
    }

    getSelectedRoles(): Role[] {
        return this.roles.filter((role) => role.selected);
    }

    getSelectedRoleNames(): string[] {
        return this.getSelectedRoles().map((role) => role.name);
    }
}
